import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IInvoice } from 'Context/CannabisContext';
import { CannabisSchema } from 'Modules/Reimbursements/Cannabis/CannabisMain/NewInvoiceForm/Schema';

export const useCannabisForm = (
  checkIfInvoiceExists: (invoiceNumber: string) => boolean,
  defaultValues?: IInvoice
) => {
  const CannabisForm = useForm<IInvoice>({
    mode: 'all',
    resolver: yupResolver(CannabisSchema(checkIfInvoiceExists)),
    defaultValues: defaultValues || {
      invoiceId: '',
      invoiceDate: null,
      invoiceTotal: null,
      file: null,
    },
  });

  return {
    CannabisForm,
  };
};
